/** @format */

export const dummyWidget = [
  {
    i: '3',
    type: 'news',
    size: 'normal',
    title: 'News & Press',
    news: [
      {
        title: 'ATE SecuBrake – Winner of the German Innovation Award!',
        content:
          'ATE SecuBrake has been recognized as a Winner at the German Innovation Award 2025 in the category Excellence in Business to Business. ATE SecuBrake has been recognized as a Winner at the German Innovation Award 2025 in the category Excellence in Business to Business.',
        nid: 12,
        date: 1773842458
      },
      {
        title: 'ATE – for the masterpiece in your workshop',
        content:
          'For 120 years, we have stood for brake expertise, OE quality, and precision engineering. Carefully tested and developed to meet the highest standards, in close partnership and ongoing dialogue with workshops.',
        nid: 10,
        date: 1773842237
      },
      {
        title: 'ATE SecuBrake – Winner of the German Innovation Award!',
        content:
          'ATE SecuBrake has been recognized as a Winner at the German Innovation Award 2025 in the category Excellence in Business to Business. \r\n',
        nid: 12,
        date: 1773842458
      },
      {
        title: 'ATE – for the masterpiece in your workshop',
        content:
          'For 120 years, we have stood for brake expertise, OE quality, and precision engineering. Carefully tested and developed to meet the highest standards, in close partnership and ongoing dialogue with workshops.',
        nid: 10,
        date: 1773842237
      },
      {
        title: 'ATE SecuBrake – Winner of the German Innovation Award!',
        content:
          'ATE SecuBrake has been recognized as a Winner at the German Innovation Award 2025 in the category Excellence in Business to Business. \r\n',
        nid: 12,
        date: 1773842458
      },
      {
        title: 'ATE – for the masterpiece in your workshop',
        content:
          'For 120 years, we have stood for brake expertise, OE quality, and precision engineering. Carefully tested and developed to meet the highest standards, in close partnership and ongoing dialogue with workshops.',
        nid: 10,
        date: 1773842237
      },
      {
        title: 'ATE SecuBrake – Winner of the German Innovation Award!',
        content:
          'ATE SecuBrake has been recognized as a Winner at the German Innovation Award 2025 in the category Excellence in Business to Business. \r\n',
        nid: 12,
        date: 1773842458
      },
      {
        title: 'ATE – for the masterpiece in your workshop',
        content:
          'For 120 years, we have stood for brake expertise, OE quality, and precision engineering. Carefully tested and developed to meet the highest standards, in close partnership and ongoing dialogue with workshops.',
        nid: 10,
        date: 1773842237
      }
    ]
  },
  {
    i: '2',
    type: 'news',
    size: 'medium',
    title: 'News & Press',
    news: [
      {
        title: 'ATE SecuBrake – Winner of the German Innovation Award!',
        content:
          'ATE SecuBrake has been recognized as a Winner at the German Innovation Award 2025 in the category Excellence in Business to Business. ATE SecuBrake has been recognized as a Winner at the German Innovation Award 2025 in the category Excellence in Business to Business.',
        nid: 12,
        date: 1773842458
      },
      {
        title: 'ATE – for the masterpiece in your workshop',
        content:
          'For 120 years, we have stood for brake expertise, OE quality, and precision engineering. Carefully tested and developed to meet the highest standards, in close partnership and ongoing dialogue with workshops.',
        nid: 10,
        date: 1773842237
      },
      {
        title: 'ATE SecuBrake – Winner of the German Innovation Award!',
        content:
          'ATE SecuBrake has been recognized as a Winner at the German Innovation Award 2025 in the category Excellence in Business to Business. \r\n',
        nid: 12,
        date: 1773842458
      },
      {
        title: 'ATE – for the masterpiece in your workshop',
        content:
          'For 120 years, we have stood for brake expertise, OE quality, and precision engineering. Carefully tested and developed to meet the highest standards, in close partnership and ongoing dialogue with workshops.',
        nid: 10,
        date: 1773842237
      },
      {
        title: 'ATE SecuBrake – Winner of the German Innovation Award!',
        content:
          'ATE SecuBrake has been recognized as a Winner at the German Innovation Award 2025 in the category Excellence in Business to Business. \r\n',
        nid: 12,
        date: 1773842458
      },
      {
        title: 'ATE – for the masterpiece in your workshop',
        content:
          'For 120 years, we have stood for brake expertise, OE quality, and precision engineering. Carefully tested and developed to meet the highest standards, in close partnership and ongoing dialogue with workshops.',
        nid: 10,
        date: 1773842237
      },
      {
        title: 'ATE SecuBrake – Winner of the German Innovation Award!',
        content:
          'ATE SecuBrake has been recognized as a Winner at the German Innovation Award 2025 in the category Excellence in Business to Business. \r\n',
        nid: 12,
        date: 1773842458
      },
      {
        title: 'ATE – for the masterpiece in your workshop',
        content:
          'For 120 years, we have stood for brake expertise, OE quality, and precision engineering. Carefully tested and developed to meet the highest standards, in close partnership and ongoing dialogue with workshops.',
        nid: 10,
        date: 1773842237
      }
    ]
  },
  {
    i: '4',
    type: 'news',
    size: 'large',
    title: 'News & Press',
    news: [
      {
        title: 'ATE SecuBrake – Winner of the German Innovation Award!',
        content:
          'ATE SecuBrake has been recognized as a Winner at the German Innovation Award 2025 in the category Excellence in Business to Business. ATE SecuBrake has been recognized as a Winner at the German Innovation Award 2025 in the category Excellence in Business to Business.',
        nid: 12,
        date: 1773842458
      },
      {
        title: 'ATE – for the masterpiece in your workshop',
        content:
          'For 120 years, we have stood for brake expertise, OE quality, and precision engineering. Carefully tested and developed to meet the highest standards, in close partnership and ongoing dialogue with workshops.',
        nid: 10,
        date: 1773842237
      },
      {
        title: 'ATE SecuBrake – Winner of the German Innovation Award!',
        content:
          'ATE SecuBrake has been recognized as a Winner at the German Innovation Award 2025 in the category Excellence in Business to Business. \r\n',
        nid: 12,
        date: 1773842458
      },
      {
        title: 'ATE – for the masterpiece in your workshop',
        content:
          'For 120 years, we have stood for brake expertise, OE quality, and precision engineering. Carefully tested and developed to meet the highest standards, in close partnership and ongoing dialogue with workshops.',
        nid: 10,
        date: 1773842237
      },
      {
        title: 'ATE SecuBrake – Winner of the German Innovation Award!',
        content:
          'ATE SecuBrake has been recognized as a Winner at the German Innovation Award 2025 in the category Excellence in Business to Business. \r\n',
        nid: 12,
        date: 1773842458
      },
      {
        title: 'ATE – for the masterpiece in your workshop',
        content:
          'For 120 years, we have stood for brake expertise, OE quality, and precision engineering. Carefully tested and developed to meet the highest standards, in close partnership and ongoing dialogue with workshops.',
        nid: 10,
        date: 1773842237
      },
      {
        title: 'ATE SecuBrake – Winner of the German Innovation Award!',
        content:
          'ATE SecuBrake has been recognized as a Winner at the German Innovation Award 2025 in the category Excellence in Business to Business. \r\n',
        nid: 12,
        date: 1773842458
      },
      {
        title: 'ATE – for the masterpiece in your workshop',
        content:
          'For 120 years, we have stood for brake expertise, OE quality, and precision engineering. Carefully tested and developed to meet the highest standards, in close partnership and ongoing dialogue with workshops.',
        nid: 10,
        date: 1773842237
      }
    ]
  },
  {
    i: '5',
    type: 'news',
    size: 'wide',
    title: 'News & Press',
    news: [
      {
        title: 'ATE SecuBrake – Winner of the German Innovation Award!',
        content:
          'ATE SecuBrake has been recognized as a Winner at the German Innovation Award 2025 in the category Excellence in Business to Business. ATE SecuBrake has been recognized as a Winner at the German Innovation Award 2025 in the category Excellence in Business to Business.',
        nid: 12,
        date: 1773842458
      },
      {
        title: 'ATE – for the masterpiece in your workshop',
        content:
          'For 120 years, we have stood for brake expertise, OE quality, and precision engineering. Carefully tested and developed to meet the highest standards, in close partnership and ongoing dialogue with workshops.',
        nid: 10,
        date: 1773842237
      },
      {
        title: 'ATE SecuBrake – Winner of the German Innovation Award!',
        content:
          'ATE SecuBrake has been recognized as a Winner at the German Innovation Award 2025 in the category Excellence in Business to Business. \r\n',
        nid: 12,
        date: 1773842458
      },
      {
        title: 'ATE – for the masterpiece in your workshop',
        content:
          'For 120 years, we have stood for brake expertise, OE quality, and precision engineering. Carefully tested and developed to meet the highest standards, in close partnership and ongoing dialogue with workshops.',
        nid: 10,
        date: 1773842237
      },
      {
        title: 'ATE SecuBrake – Winner of the German Innovation Award!',
        content:
          'ATE SecuBrake has been recognized as a Winner at the German Innovation Award 2025 in the category Excellence in Business to Business. \r\n',
        nid: 12,
        date: 1773842458
      },
      {
        title: 'ATE – for the masterpiece in your workshop',
        content:
          'For 120 years, we have stood for brake expertise, OE quality, and precision engineering. Carefully tested and developed to meet the highest standards, in close partnership and ongoing dialogue with workshops.',
        nid: 10,
        date: 1773842237
      },
      {
        title: 'ATE SecuBrake – Winner of the German Innovation Award!',
        content:
          'ATE SecuBrake has been recognized as a Winner at the German Innovation Award 2025 in the category Excellence in Business to Business. \r\n',
        nid: 12,
        date: 1773842458
      },
      {
        title: 'ATE – for the masterpiece in your workshop',
        content:
          'For 120 years, we have stood for brake expertise, OE quality, and precision engineering. Carefully tested and developed to meet the highest standards, in close partnership and ongoing dialogue with workshops.',
        nid: 10,
        date: 1773842237
      }
    ]
  },
  {
    i: '6',
    type: 'news',
    size: 'xwide',
    title: 'News & Press',
    news: [
      {
        title: 'ATE SecuBrake – Winner of the German Innovation Award!',
        content:
          'ATE SecuBrake has been recognized as a Winner at the German Innovation Award 2025 in the category Excellence in Business to Business. ATE SecuBrake has been recognized as a Winner at the German Innovation Award 2025 in the category Excellence in Business to Business.',
        nid: 12,
        date: 1773842458
      },
      {
        title: 'ATE – for the masterpiece in your workshop',
        content:
          'For 120 years, we have stood for brake expertise, OE quality, and precision engineering. Carefully tested and developed to meet the highest standards, in close partnership and ongoing dialogue with workshops.',
        nid: 10,
        date: 1773842237
      },
      {
        title: 'ATE SecuBrake – Winner of the German Innovation Award!',
        content:
          'ATE SecuBrake has been recognized as a Winner at the German Innovation Award 2025 in the category Excellence in Business to Business. \r\n',
        nid: 12,
        date: 1773842458
      },
      {
        title: 'ATE – for the masterpiece in your workshop',
        content:
          'For 120 years, we have stood for brake expertise, OE quality, and precision engineering. Carefully tested and developed to meet the highest standards, in close partnership and ongoing dialogue with workshops.',
        nid: 10,
        date: 1773842237
      },
      {
        title: 'ATE SecuBrake – Winner of the German Innovation Award!',
        content:
          'ATE SecuBrake has been recognized as a Winner at the German Innovation Award 2025 in the category Excellence in Business to Business. \r\n',
        nid: 12,
        date: 1773842458
      },
      {
        title: 'ATE – for the masterpiece in your workshop',
        content:
          'For 120 years, we have stood for brake expertise, OE quality, and precision engineering. Carefully tested and developed to meet the highest standards, in close partnership and ongoing dialogue with workshops.',
        nid: 10,
        date: 1773842237
      },
      {
        title: 'ATE SecuBrake – Winner of the German Innovation Award!',
        content:
          'ATE SecuBrake has been recognized as a Winner at the German Innovation Award 2025 in the category Excellence in Business to Business. \r\n',
        nid: 12,
        date: 1773842458
      },
      {
        title: 'ATE – for the masterpiece in your workshop',
        content:
          'For 120 years, we have stood for brake expertise, OE quality, and precision engineering. Carefully tested and developed to meet the highest standards, in close partnership and ongoing dialogue with workshops.',
        nid: 10,
        date: 1773842237
      }
    ]
  },
  {
    i: '7',
    type: 'news',
    size: '2xl',
    title: 'News & Press',
    news: [
      {
        title: 'ATE SecuBrake – Winner of the German Innovation Award!',
        content:
          'ATE SecuBrake has been recognized as a Winner at the German Innovation Award 2025 in the category Excellence in Business to Business. ATE SecuBrake has been recognized as a Winner at the German Innovation Award 2025 in the category Excellence in Business to Business.',
        nid: 12,
        date: 1773842458
      },
      {
        title: 'ATE – for the masterpiece in your workshop',
        content:
          'For 120 years, we have stood for brake expertise, OE quality, and precision engineering. Carefully tested and developed to meet the highest standards, in close partnership and ongoing dialogue with workshops.',
        nid: 10,
        date: 1773842237
      },
      {
        title: 'ATE SecuBrake – Winner of the German Innovation Award!',
        content:
          'ATE SecuBrake has been recognized as a Winner at the German Innovation Award 2025 in the category Excellence in Business to Business. \r\n',
        nid: 12,
        date: 1773842458
      },
      {
        title: 'ATE – for the masterpiece in your workshop',
        content:
          'For 120 years, we have stood for brake expertise, OE quality, and precision engineering. Carefully tested and developed to meet the highest standards, in close partnership and ongoing dialogue with workshops.',
        nid: 10,
        date: 1773842237
      },
      {
        title: 'ATE SecuBrake – Winner of the German Innovation Award!',
        content:
          'ATE SecuBrake has been recognized as a Winner at the German Innovation Award 2025 in the category Excellence in Business to Business. \r\n',
        nid: 12,
        date: 1773842458
      },
      {
        title: 'ATE – for the masterpiece in your workshop',
        content:
          'For 120 years, we have stood for brake expertise, OE quality, and precision engineering. Carefully tested and developed to meet the highest standards, in close partnership and ongoing dialogue with workshops.',
        nid: 10,
        date: 1773842237
      },
      {
        title: 'ATE SecuBrake – Winner of the German Innovation Award!',
        content:
          'ATE SecuBrake has been recognized as a Winner at the German Innovation Award 2025 in the category Excellence in Business to Business. \r\n',
        nid: 12,
        date: 1773842458
      },
      {
        title: 'ATE – for the masterpiece in your workshop',
        content:
          'For 120 years, we have stood for brake expertise, OE quality, and precision engineering. Carefully tested and developed to meet the highest standards, in close partnership and ongoing dialogue with workshops.',
        nid: 10,
        date: 1773842237
      }
    ]
  }
];
